import { ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div
      className="fixed inset-0 bg-[var(--theme-page-bg)] text-[var(--theme-text-primary)]"
      // style={{
      //   paddingTop: 'env(safe-area-inset-top)',
      //   // paddingBottom: 'env(safe-area-inset-bottom)',
      //   paddingBottom: 'env(safe-area-inset-bottom)',
      //   paddingLeft: 'env(safe-area-inset-left)',
      //   paddingRight: 'env(safe-area-inset-right)',
      // }}
    >
      {/* <NavigationBar /> */}
      {/* 内容区域需要有一个顶部边距，避免被导航栏遮挡 */}
      <div className="h-full">{children}</div>
    </div>
  );
};

export default Layout;
